import { Body1, Button, Title1 } from '@fluentui/react-components';
import { bundleIcon, Bot48Filled, Bot48Regular } from '@fluentui/react-icons';
import { useNavigate } from 'react-router';

import { useStyles } from './NotFoundPage.style';

const DroidIcon = bundleIcon(Bot48Filled, Bot48Regular) as React.FC;

export function NotFoundPage() {
  const styles = useStyles();
  const navigate = useNavigate();

  return (
    <div className={styles.root}>
      <span className={styles.droid}>
        <DroidIcon />
      </span>
      <Title1>Page not found</Title1>
      <Body1>These are not the pages you&apos;re looking for.</Body1>
      <Button appearance="primary" onClick={() => void navigate('/')}>
        Go home
      </Button>
    </div>
  );
}
